import { render, staticRenderFns } from "./product-firewood.vue?vue&type=template&id=bc528bbc"
import script from "./product-firewood.vue?vue&type=script&lang=js"
export * from "./product-firewood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackreeve/projects/logshed/wp-content/themes/logshed/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc528bbc')) {
      api.createRecord('bc528bbc', component.options)
    } else {
      api.reload('bc528bbc', component.options)
    }
    module.hot.accept("./product-firewood.vue?vue&type=template&id=bc528bbc", function () {
      api.rerender('bc528bbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/product-firewood.vue"
export default component.exports